exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-stat-card__value[data-v-5b132e36]{font-size:1.75rem;font-weight:700;line-height:1.2;margin-top:.25rem}.dashboard-stat-card__icon[data-v-5b132e36]{font-size:1.5rem;opacity:.35}.dashboard-stat-card--clickable[data-v-5b132e36]{cursor:pointer;transition:box-shadow .15s ease}.dashboard-stat-card--clickable[data-v-5b132e36]:hover{box-shadow:0 .125rem .5rem rgba(0,0,0,.12)}", ""]);

// exports
